import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';

const getThreadMetaValue = ({ threadMetaByIdValue, threadId }) => {
  const normalizedThreadId = getNormalizedThreadId(threadId);

  if (!normalizedThreadId) {
    return null;
  }

  return threadMetaByIdValue?.[normalizedThreadId] || null;
};

export default getThreadMetaValue;
